export const LAYER_IDS_FILTER_KEY = 'layer_ids';
export const FILTER_SELECTED_LAYERS_KEYS = [
  'industrialLayers',
  'officeLayers',
  'retailLayers',
  'multiFamilyLayers',
  'farmAndRanchLayers',
  'laborLayers',
  'transportationLayers',
  'residentialLayers'
];
